import { useCallback, useMemo, useState } from 'react';

import {
  County,
  useLocationsCountiesListQuery,
} from 'src/common/external/bambi-api/bambiApi';
import { ItemSelector } from 'src/common/ItemSelector/ItemSelector';

export function CountiesFilter({
  selectedCounties,
  onCountyChange,
}: {
  selectedCounties: County[];
  onCountyChange: (counties: County[]) => void;
}) {
  const [searchTerm, setSearchTerm] = useState('');

  const {
    countyItems,
    isLoading: countiesLoading,
    isFetching: countiesFetching,
  } = useLocationsCountiesListQuery(
    {
      county: searchTerm,
    },
    {
      selectFromResult: (result) => {
        const countyItems = result.data?.results.map((county) => ({
          id: `${county.state}:${county.county}`,
          state: county.state,
          county: county.county,
        }));
        return {
          ...result,
          countyItems,
        };
      },
    }
  );

  const selectedCountiesItems = useMemo(
    () =>
      selectedCounties.map((county) => ({
        id: `${county.state}:${county.county}`,
        state: county.state,
        county: county.county,
      })),
    [selectedCounties]
  );

  const handleCountyChange = useCallback(
    (counties: { id: string; state: string; county: string }[]) => {
      onCountyChange(
        counties.map((county) => ({
          state: county.state,
          county: county.county,
        }))
      );
    },
    [onCountyChange]
  );

  return (
    <ItemSelector
      items={countyItems ?? []}
      selectedItems={selectedCountiesItems}
      loading={countiesLoading}
      searching={countiesFetching}
      onSelectionChange={handleCountyChange}
      getItemLabel={(item) => `${item.county}, ${item.state}`}
      dataTestId="counties-filter-search"
      noItemsText="No counties found."
      onSearchChange={setSearchTerm}
      searchPlaceholder="Search by county"
    />
  );
}
